module.exports = __webpack_public_path__ + "img/eLearning_content_img_06.fb4ee1a6.jpg";